import {
  AKA_HEALTH_ABOUT_YOU_STEP,
  AKA_HEALTH_YOUR_HEALTH_STEP,
} from "Components/Features/CheckPrice/Products/LifeProducts/AkaHealth";

import { AkaHealthProductDetailsFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/AkaHealth/ProductDetails/akaHealthProductDetailsInterfaces";
import { AkaHealthProductIntroFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/AkaHealth/ProductIntro/akaHealthProductIntroInterfaces";
import { AkaHealthWithoutSigningProperties } from "Components/Features/CheckPrice/Products/LifeProducts/AkaHealth/akaHealthInterfaces";
import { PersonalApplicantInformation } from "Store/interfaces/PersonalApplicantInformation";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { formBooleanToBoolean } from "Utils/formUtils";

export interface AkaHealthWithoutSigningProductBackend {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: string;
  memberApplicantPersonInformation: PersonalApplicantInformation;
  memberHealthQuestions: AkaHealthWithoutSigningProperties;
  isScandinavianCitizen: boolean;
}

export const mapToCommerceAkaHealth = (
  data: Record<string, any>,
): AkaHealthWithoutSigningProductBackend => {
  const akaHealthIntroData: AkaHealthProductIntroFormValues =
    data.formData[AKA_HEALTH_ABOUT_YOU_STEP.id];
  const akaHealthDetailsData: Omit<
    AkaHealthProductDetailsFormValues,
    "isOnSickLeave"
  > = data.formData[AKA_HEALTH_YOUR_HEALTH_STEP.id];

  return {
    name: INSURANCE_NAME_VALUE.AKA_HEALTH_WITHOUT_SIGNING,
    coverageGroup: data.coverage,
    isScandinavianCitizen: formBooleanToBoolean(
      akaHealthIntroData.isMemberOfNordicSocialSecurity,
    ),
    memberApplicantPersonInformation: {
      dateOfBirth: data.customerData.newCustomerResponse.dateOfBirth,
    },
    memberHealthQuestions: {
      isFitForWork: formBooleanToBoolean(akaHealthDetailsData.isFitForWork),
      inTreatment: formBooleanToBoolean(akaHealthDetailsData.inTreatment),
      isPlannedAnyKindOfTreatment: formBooleanToBoolean(
        akaHealthDetailsData.isPlannedAnyKindOfTreatment,
      ),
      hasNationalInsurance: formBooleanToBoolean(
        akaHealthIntroData.isMemberOfNordicSocialSecurity,
      ),
    },
  };
};
